<template>
  <div class="mt-2 md:mt-0 pt-10 px-5">
    <h2 class="text-3xl mb-6">{{ $t('all_order') }}</h2>
    <div v-if="orders && orders?.length > 0">
      <div class="products-list grid gap-x-6 gap-y-3 grid-cols-1 xl:grid-cols-2 pb-3">
        <locale-link v-for="order in orders" :key="order.id" :to="`/orders/${order.id}`">
          <order-card :order="order" />
        </locale-link>
      </div>
      <div v-if="totalCount && totalCount > 10" class="paging py-6 pb-10">
        <nd-pagination v-model:page="pagingState.page" :page-size="pagingState.size" :total-count="totalCount" />
      </div>
    </div>
    <list-no-result v-else-if="orders?.length === 0">
      <span class="whitespace-pre-line">{{ $t('booking_list_empty') }}</span>
    </list-no-result>
  </div>
</template>

<script setup lang="ts">
import ListNoResult from '@/components/common/list-no-result.vue'
import OrderCard from '@/components/order/order-card.vue'
import { getOrders } from '@/service/order'
import { ASYNC_DATA_KEYS } from '@/constants/async-data-keys'

definePageMeta({
  layout: 'member',
  middleware: ['auth-required', 'check-region'],
})

const PAGE_SIZE = 10

const pagingState = reactive({
  page: 1,
  size: PAGE_SIZE,
})

const { data } = useAsyncData(
  useAsyncDataKey(ASYNC_DATA_KEYS.MEMBER_ORDERS, []),
  async () => {
    const { data: orders, total_count } = await getOrders({ size: pagingState.size, start: (pagingState.page - 1) * PAGE_SIZE })
    return { orders, total_count }
  },
  { server: false, watch: [pagingState] }
)

const orders = computed(() => data.value?.orders)
const totalCount = computed(() => data.value?.total_count)
</script>

<style lang="scss" scoped></style>
